module.exports = __webpack_public_path__ + "img/project_e6.be0da085.png";